import { jsx as _jsx } from "react/jsx-runtime";
import { detectSkill } from './detectSkill';
import { Skill } from './Skill';
export function renderSkill(skillApi, param) {
    if (!param.text) {
        return null;
    }
    var path = detectSkill(param.text);
    if (!path) {
        return null;
    }
    if (!skillApi.isAvailableSkill(path)) {
        return null;
    }
    var _a = toTokenParam(path, param), id = _a[0], tokenParam = _a[1];
    return (_jsx(Skill, { src: "".concat(skillApi.baseUrl).concat(path), id: id, token: skillApi.token, customer: skillApi.customer, params: skillApi.params, from: param.from, preview: skillApi.preview, tokenParam: tokenParam }));
}
function toTokenParam(path, param) {
    var formId = path.replace(/^.*?form=([^&]+?)(?:&.+)?$/, '$1');
    if (param.from === 'FAQ_ANSWER' && param.cardId) {
        return [
            formId,
            { from: param.from, formId: formId, cardId: param.cardId, answerId: param.answerId || undefined },
        ];
    }
    if ((param.from === 'FAQ_FEEDBACK_NO' || param.from === 'FAQ_FEEDBACK_YES') && param.cardId) {
        return [formId, { from: param.from, formId: formId, cardId: param.cardId }];
    }
    throw new Error('invalid parameter');
}
//# sourceMappingURL=renderSkill.js.map